import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { AuthenticationService } from 'src/app/dataServices/authDataService';
import { User } from 'src/app/models/user';
import { AppState } from 'src/app/services/app.service';
import { SecurityService } from 'src/app/services/securityService';
@Component({
    selector: 'self-ins-login',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {
    public email: string = '';
    public password: string = '';
    public isSubmit = false;
    public user: User | null = null;
    public isLoginError = false;

    public constructor(private router: Router,
                       private progressBar: NgProgress,
                       private appState: AppState,
                       private securityService: SecurityService,
                       private authDataService: AuthenticationService) {}
    public onSubmit() {
        this.isLoginError = false;
        this.progressBar.ref().start();
        this.isSubmit = true;

        this.authDataService.login(this.email, this.password)
        .subscribe(
            (userData) => {
                this.securityService.setToken(userData.token);
                this.appState.updateUser(userData.identity);
                this.user = userData.identity;
                this.progressBar.ref().complete();
                this.router.navigate(['/home']);
            },
            (_error) => {
                this.isLoginError = true;
                this.isSubmit = false;
                this.progressBar.ref().complete();
            }
        );
    }
}